// ============================================
// 🍏 POLYFILLS PARA COMPATIBILIDADE COM iPHONES
// ============================================
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'es6-promise/auto';

// ============================================
// SEU CÓDIGO ORIGINAL (mantido intacto)
// ============================================
import Vue from "vue";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.snow.css";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
  position: "bottom-right",
});

Vue.use(VueQuillEditor);
Vue.config.productionTip = false;

// Tratamento global de erros para permissões e outros erros não capturados
Vue.config.errorHandler = function (err, vm, info) {
  if (err.message.includes("Permissions check failed")) {
    console.warn("Erro de permissão capturado:", err.message);
    // Ignorar erro de permissões se não for crítico
    return;
  }
  console.error("Erro Vue global:", err, info);
};

// Tratamento global de erros de promises rejeitadas
window.addEventListener("unhandledrejection", function (event) {
  if (event.reason?.message?.includes("Permissions check failed")) {
    // console.warn('Promise rejeitada por erro de permissão:', event.reason.message);
    event.preventDefault(); // Previne que o erro apareça no console
    return;
  }
  console.error("Promise rejeitada não tratada:", event.reason);
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");